import { useState, useEffect } from "react";
import type { ReactNode } from "react";
import { Grid, MenuItem } from "@mui/material";
import { competencesUtil } from "utils";
import { useErrorHandler } from "utils/errorHandling";
import LoadingScreen from "components/Template/LoadingScreen";
import { RaisonCreationTransfertLibelles } from "models";
import type { Perimetre } from "models";
import { perimetresService } from "services";
import ControlledDateTime from "components/inputs/ControlledDateTime";
import ControlledPerimetreAutoComplete from "components/inputs/ControlledPerimetreAutoComplete";
import ControlledTextField from "components/inputs/ControlledTextField";
import { validDateRules } from "constants/InputRules";
import { sortUtil } from "utils/sortUtil";

function NewTransfertInformationsPrincipales(): ReactNode {
  const [perimetres, setPerimetres] = useState<Array<Perimetre>>([]);

  const { catchErrors, isLoading } = useErrorHandler();

  useEffect(() => {
    async function getPerimetres(): Promise<void> {
      const _perimetres = await perimetresService.getAll();
      _perimetres.sort(
        sortUtil.combineMultipleSort(
          (a, b) => a.libelle.localeCompare(b.libelle),
          competencesUtil.sortPerimetresByCompetence
        )
      );
      setPerimetres(_perimetres);
    }

    void catchErrors(getPerimetres);
  }, [catchErrors]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={{ xs: 12, md: 4 }}>
        <ControlledDateTime
          name="dateDeliberation"
          rules={{
            required: "Choisir une date de délibération est obligatoire",
            ...validDateRules,
          }}
          label="Date de délibération *"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ControlledDateTime
          name="dateAssembleeGenerale"
          rules={{
            required: "Choisir une date d'Assemblée Générale est obligatoire",
            ...validDateRules,
          }}
          label="Date d'Assemblée Générale *"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <ControlledDateTime
          name="dateDebut"
          rules={{
            required: "Choisir une date de début est obligatoire",
            ...validDateRules,
          }}
          label="Date de début *"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ControlledPerimetreAutoComplete
          name="perimetre"
          label="Périmètre concerné *"
          rules={{ required: "Ce champ est obligatoire" }}
          perimetres={perimetres}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <ControlledTextField
          select
          name="raisonCreation"
          rules={{ required: "La raison de création de transfert est obligatoire" }}
          label="Raison de création de transfert *">
          {RaisonCreationTransfertLibelles.map((raison) => (
            <MenuItem key={raison} value={raison}>
              {raison}
            </MenuItem>
          ))}
        </ControlledTextField>
      </Grid>
    </Grid>
  );
}

export default NewTransfertInformationsPrincipales;
